import { connect } from 'react-redux';
import challengeActions from '../../../../store/actions/challenge.action';
import PrimerFactor from './PrimerFactor';

const mapStateToProps = state => ({
  challengeResponse: state.challenge.challengeResponse,
  isLoading: state.challenge.loading,
  errorChallengeValidate: state.challenge.errorChallengeValidate,
  errorInput: state.challenge.errorInput,
  errorMessage: state.challenge.errorMessage
});

const mapDispatchToProps = dispatch => {
  return {
    changeChallengeResponse: value => {
      dispatch(challengeActions.changeChallengeResponse(value));
    },
    validateChallenge: password => {
      dispatch(challengeActions.validateChallenge(password));
    },
    removeError: () => {
      dispatch(challengeActions.removeError());
    },
    changeErrorMessage: (message) => {
      dispatch(challengeActions.changeErrorMessage(message));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrimerFactor);
